import { OnChanges, Input, Output, EventEmitter, OnInit, Directive } from '@angular/core';
import { ProvidersService, AppService, DaoService, LogService, MessageService, FCCONFIG, CommonService } from 'fccore2';
import { FcEvent } from './business/fcevent.event';
import { Fcomponent } from './f';
export class FcComponent extends Fcomponent implements OnChanges, OnInit {
    // ææäºä»¶åç§°
    fcevent: any = FcEvent.fcnavbar;
    /** åæ°æ®æå¡ï¼æä¾åæ°æ®çå¢å æ¹æ¥æ¥å£çæå¡ */
    appService: AppService;
    /** httpè¯·æ±æå¡ï¼æä¾è®¿é®åç«¯æå¡ï¼åå«get post ç­æ¹æ³ */
    daoService: DaoService;
    /** æ¥å¿æå¡ç±»ï¼æä¾åè¡ä¸ºæ¥å¿æ¥å¿ï¼ */
    logService: LogService;
    // æ¶æ¯æå¡
    msgService: MessageService;
    @Input()
    fcUrl: string = 'SYSTEM/SYSMODEL/listinfo';
    @Input()
    fcRequestParam: any = {};
    /** ç»ä»¶ç¶æ */
    @Input()
    fcStatus: string;
    /** è¡åæ ·å¼ */
    @Input()
    fcStyle: any;
    /** æ · å¼ç±» */
    @Input()
    fcClass: string;
    /** ç»ä»¶å¤§å°ï¼åsmallï¼defaultï¼large */
    @Input()
    fcSize: string = FCCONFIG.param.style.COMPONENTSIZE ||  FCSIZE.small;
    /** æ¯å¦ç¦ç¨ é»è®¤ä¸ºä¸ç¦ç¨,'Y'è¡¨ç¤ºç¦ç¨ï¼'N'è¡¨ç¤ºä¸ç¦ç¨ */
    @Input()
    fcDisabled: string = 'N';
    // tslint:disable-next-line:variable-name
    _disabled: boolean;
    /**
     * ä¸»é¢
     */
    @Input()
    fcTheme: string = FCCONFIG.param.style.theme || 'light' ;
    /**
     * äºä»¶
     */
    @Output()
    fcEvent: EventEmitter<any> = new EventEmitter();
    // ä¾èµæ³¨å¥
    constructor(public provider: ProvidersService, public id?: string) {
        super();
        this.appService = provider.appService;
        this.daoService = provider.daoService;
        this.logService = provider.logService;
        this.msgService = provider.msgService;
        this.fcId = id === undefined ? id : CommonService.guid();
        this.fcUuid = CommonService.guid();
    }
    // åå§åç»ä»¶
    ngOnInit(): void {
    }
    // è¾å¥å±æ§æ¹åæ¶è§¦å
    ngOnChanges(param): void {
        if (this.fcSize === undefined) {
            this.fcSize = FCSIZE.small;
        }
    }
    /**
     * ææäºä»¶çåºå£
     * @param eventName äºä»¶å
     * @param param è¿ååæ°
     */
    event(eventName: string, param: any) {
        this.fcEvent.emit({
            eventName,
            param
        });
    }
    /**
     * åæ¶äºä»¶è®¢é
     */
    ngOnDestroy() {
        this.fcEvent.unsubscribe();
        super.ngOnDestroy();
    }
}
/**
 * ç»ä»¶å¤§å°ï¼é»è®¤æ¯default
 */
export const FCSIZE = {
    small: 'small',
    default: 'default',
    large: 'large'
};
/**
 * äºä»¶
 */
export interface FCEVENT {
    /** äºä»¶åç§° */
    eventName: string;
    /** äºä»¶åæ°åå®¹ */
    param: any;
}
